import PubSub from "underpub-js";
import Swiper from 'swiper';

var ListingLatestNews = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ListingLatestNews',
	};

	$.extend(true, this.options, options);

};

ListingLatestNews.prototype.init = function() {

	var self = this;

	self.$slides = self.options.$el.find(`.${self.options.baseClass}__cards`);

	self.initCarousel();
};

ListingLatestNews.prototype.initCarousel = function() {

	var self = this;

	let swiperOptions = {
		loop: true,
		slidesPerView: 1.478,
		spaceBetween: 16,
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
		breakpoints: {
			// small (>=560px)
			// 560: {
			// 	slidesPerView: 1.8,
			// },
			// medium (>=768px)
			768: {
				spaceBetween: 16,
				slidesPerView: 2.4,
			},
			// large (>=1024px)
			1024: {
				spaceBetween: 24,
				slidesPerView: 3,
			},
			// xlarge (>=1440px)
			1440: {
				spaceBetween: 36,
				slidesPerView: 3
			}
		}

	};


	self.swiper = new Swiper(self.$slides[0], swiperOptions);

};

export default ListingLatestNews;
